const listaDeProvedoresMulta = (state) => state.listaProvedores;

const loadingProvedoresMulta = (state) => state.carregando;

const provedor = (state) => state.provedor;

const workflowsProvedor = (state) => state.workflows;

const loadingProvedorMulta = (state) => state.carregando;

const paginacaoProvedores = (state) => state.paginacaoProvedores || {};

const paginacaoWorkflows = (state) => state.paginacaoWorkflows || {};

const filtroData = (state) => state.filtroData;

export {
  listaDeProvedoresMulta,
  loadingProvedoresMulta,
  provedor,
  workflowsProvedor,
  loadingProvedorMulta,
  paginacaoProvedores,
  paginacaoWorkflows,
  filtroData
};
